import colors from "@assets/colors";
import SVGIcon from "@assets/svg";
import { ODOO_HELPDESK_TOKEN, ODOO_HELPDESK_URL } from "@env";
import Icon from "@expo/vector-icons/MaterialIcons";
import { AuthContext } from "@src/AuthProvider";
import Button from "@src/components/button/Button01";
import { TextInput02 } from "@src/components/textinput";
import { useAppSelector } from "@src/ducks/ducksHook";
import { desktopSize, mobileSize, tabletSize } from "@src/utils/screensize-helper";
import _ from "lodash";
import React, { forwardRef, useContext, useState } from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import { DrawerContext } from "../drawer-screens/drawer-provider";
import useStyles from "./styles";
import SuccessModal from "./success-modal";
import useOrientationHelper from "@src/utils/orientation-helper";
import BackButton from "./back-button";
import { selectedAuthGuestRole } from "@src/ducks/slices/auth.slice";
import GetHelp from "./getHelp";

const Support = forwardRef(({ isVisible, setIsVisible }: any, ref: any) => {
  const styles = useStyles();
  const { activeTab } = useContext(DrawerContext);
  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>(false);
  const { onActiveTab, setIsMaximize } = useContext(DrawerContext);
  const isMobile = mobileSize();
  const isTablet = tabletSize();
  const isDesktop = desktopSize();
  const isLandScape = useOrientationHelper();
  const isGuest = useAppSelector(selectedAuthGuestRole);
  const [showGetHelp, setShowGetHelp] = useState(false);

  const onClickMaximize = () => {
    onActiveTab("Support");
    setIsVisible(false);
    setIsMaximize(true);
  };

  const onClickFAQsBtn = () => {
    onActiveTab("FAQs");
    setIsVisible(false);
  };

  const onClickGetHelpBtn = () => {
    setShowGetHelp(true);
  };

  const ContainerScrollView = isMobile ? View : ScrollView;

  return (
    <>
    {/* <View style={!isVisible ? styles.backButtonGuest : styles.displayHide}>
        <BackButton />
    </View> */}
    <View ref={ref} style={[isMobile && styles.container, isLandScape && styles.containerLandscape]}>
      <Text style={[styles.header_label]}>{isVisible || isMobile ? "" : "How can we help you?"}</Text>
      {
        isVisible &&
        <View style={styles.header}>
          <Text style={styles.headerText}>Support</Text>
          <View style={styles.icons}>
            <Icon style={styles.icon} onPress={() => setIsVisible(false)} name="minimize" size={15} color="white" />
            <Icon style={styles.icon} onPress={onClickMaximize} name="open-in-full" size={15} color="white" />
            <Icon style={styles.icon} onPress={() => setIsVisible(false)} name="close" size={15} color="white" />
          </View>
        </View>
      }
      <ContainerScrollView 
        contentContainerStyle={[styles.contentContainer, 
          activeTab === "Support" && styles.contentContainerHeight,
          isVisible && styles.marginChatbox && styles.tabletContainerSize, 
          isGuest && styles.tabletGuest, isLandScape && styles.landScapeMobile]} 
        showsVerticalScrollIndicator={false} 
        showsHorizontalScrollIndicator={false}
      >
        {/* <View style={[!isVisible && styles.cardContainer, isVisible && styles.maximizedSupportPage, isTablet && styles.tabContainer]}>  
          <View>
            <Text>
              Need Help?
            </Text>
            <Button label="SignSecure V2 FAQs" style={styles.faqs_btn} onPress={onClickGetHelpBtn} />
          </View>
        </View> */}
         {showGetHelp ? (
            <GetHelp isVisible={isVisible} setIsVisible={setIsVisible} />
          ) : (
            <View style={[!isVisible && styles.cardContainer, isVisible && styles.maximizedSupportPage, isTablet && styles.tabContainer]}>  
              <View>
                <Text style={styles.headerTextTitle}>
                  Need Help?
                </Text>
                <Text>             
                  Fill out the form to reach our support team, and we'll assist you as soon as possible. You can also browse our FAQs for quick answers to common questions
                </Text>
                <View style={{paddingBottom: "60%"}} />
                <Button label="Get Help" style={styles.getHelp_btn} onPress={onClickGetHelpBtn} />
                <View style={{paddingBottom: 28}} />
                <Button label="SignSecure V2 FAQs" style={styles.faqs_btn} onPress={onClickFAQsBtn} />
              </View>
            </View>
          )}
      </ContainerScrollView>
      <SuccessModal visible={openSuccessModal} />
      <View style={styles.v_extraheight} />
    </View>
    </>
  );
});

export default Support;